import { Component } from '@angular/core';
import { ProductDetails } from '../../../../components/admin-dashboard-component/product-details/product-details';

@Component({
  selector: 'app-view-product',
  imports: [ProductDetails],
  templateUrl: './view-product.html',
  styleUrl: './view-product.scss',
})
export class ViewProduct {}
